export const labels = {
	differentAccountPopup: {
		title: {
			label: "Label.MobileCreator.LoginManager.DifferentAccount.Title",
			default: "Invalid account",
		},
		message: {
			label: "Label.MobileCreator.LoginManager.DifferentAccount.Message",
			default: "You are no longer logged in with the account that owns this project.",
		},
	},
	loggedOutPopup: {
		title: {
			label: "Label.MobileCreator.LoginManager.LoggedOut.Title",
			default: "You are logged out",
		},
		message: {
			label: "Label.MobileCreator.LoginManager.LoggedOut.Message",
			default: "You must login again to continue with your project.",
		},
		loginButton: {
			label: "Label.MobileCreator.LoginManager.LoggedOut.LoginButton",
			default: "Login",
		},
	},
	goToHomepageButton: {
		label: "Label.MobileCreator.LoginManager.GoToHomepageButton",
		default: "Go to homepage",
	},
} as const;
